var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "p-dashboard-card", class: _vm.classCard },
    [
      _c(
        "div",
        { staticClass: "dashboard-card", class: _vm.classCardWrapper },
        [
          _c("div", { staticClass: "dashboard-card-header" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _vm._t("icon"),
                _vm._v(" "),
                _c(
                  "h3",
                  { staticClass: "dashboard-card-title", style: _vm.title },
                  [_vm._v(_vm._s(_vm.title))]
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.withFilters
              ? _c(
                  "div",
                  {
                    staticClass: "dashboard-card-filters",
                    on: {
                      click: function($event) {
                        _vm.openedFilters = !_vm.openedFilters
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.selectedFilter ? _vm.selectedFilter.name : ""
                        ) +
                        "\n        "
                    ),
                    _vm.selectedFilter
                      ? _c("span", { staticClass: "mod-icon-chevron-down" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.openedFilters
                      ? _c(
                          "div",
                          { staticClass: "filters-list" },
                          _vm._l(_vm.filters, function(filter, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "filter-option",
                                on: {
                                  click: function($event) {
                                    _vm.selectFilter(filter)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(filter.name))]
                            )
                          })
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-card-body mt-3" },
            [_vm._t("body")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbb0ac06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbb0ac06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/SalesDashboardCard.vue
// module id = null
// module chunks = 